import * as authDrawerConstants from "../constants/authDrawer";
import * as appConstants from "../config/constants";
import backend from "./backend";
import * as actionTypes from "../constants/actionTypes";
import {
  setLocalItem,
  getLocalItem,
  removeLocalItem,
} from "./localdb";

export const eventFilter = (event, expectedSource) => {
  try {
    return event
      && event.origin === window.location.origin
      && event.isTrusted
      && event.source
      && "name" in event.source
      && event.source.name === expectedSource
      && event.data
      && "authToken" in event.data
      && event.data.authToken;
  } catch (e) {
    return false;
  }
};

// Refresh token by opening up invisible iFrame
export const refreshToken = () => {
  // The token will be refreshed, so there's no reason to keep it anymore.
  removeLocalItem("authToken");

  const framePromise = new Promise((resolve) => {
    const iframe = document.createElement("iframe");

    iframe.src = authDrawerConstants.AUTH_URL;
    iframe.width = 0;
    iframe.height = 0;
    iframe.style.border = "none";
    iframe.name = "reauthorization iframe";

    document.body.appendChild(iframe);

    window.addEventListener("message", (event) => {
      if (eventFilter(event, iframe.name)) {
        resolve(event.data.authToken);
        iframe.remove();
      }
    });
  });

  const timeoutPromise = new Promise((resolve, reject) => {
    const timeoutId = window.setTimeout(() => {
      window.clearTimeout(timeoutId);
      reject();
    }, 5000);
  });

  return Promise.race([framePromise, timeoutPromise]);
};

export const updateAxiosToken = (token) => {
  let authToken;

  if (token) {
    authToken = token;

    setLocalItem("authToken", authToken, { expires: 31 });
  } else {
    authToken = getLocalItem("authToken");
  }

  // Update Axios instance to send headers after auth
  backend.defaults.headers.common = {
    ...backend.defaults.headers.common,
    Authorization: `Bearer ${authToken}`,
  };
};

export const checkAuthStatus = () => {
  return (dispatch) => {
    if (getLocalItem("authToken")) {
      return dispatch({
        type: actionTypes.LOGGED_IN_STATUS,
        payload: true,
      });
    } else {
      dispatch({
        type: actionTypes.LOGGED_IN_STATUS,
        payload: false,
      });
    }
  };
};

// Log out of the backend
export const backendLogOut = () => {
  const iframe = document.createElement("iframe");

  iframe.src = authDrawerConstants.LOGOUT_URL;
  iframe.width = 0;
  iframe.height = 0;
  iframe.style.border = "none";
  iframe.name = "logout iframe";

  document.body.appendChild(iframe);
};

export const setNonce = () => {
  if (!window) { return }
  let socialNonce;

  if (window.crypto && window.crypto.getRandomValues) {
    socialNonce = window.crypto.getRandomValues(new Uint32Array(1))[0].toString();
  } else {
    socialNonce = (Math.random()*1e10).toString(36);
  }

  setLocalItem("socialNonce", socialNonce);
};

const getNonce = () => getLocalItem("socialNonce");

const getAuthorizeUrl = () => {
  const nonce = getNonce();
  const socialRedirectUri = encodeURIComponent(`${appConstants.FRONTEND_ROOT}/authorize?next=${encodeURIComponent(appConstants.FRONTEND_ROOT)}`);
  return `${appConstants.BACKEND_ROOT}/o/authorize?client_id=${authDrawerConstants.CLIENT_ID}&redirect_uri=${socialRedirectUri}&scope=read%20write&response_type=token&state=${nonce}`;
};

export const getFacebookUrl = () => {
  const authUrl = getAuthorizeUrl();
  return `${appConstants.BACKEND_ROOT}/login/facebook/?next=${encodeURIComponent(authUrl)}`;
};

export const getLinkedInUrl = () => {
  const authUrl = getAuthorizeUrl();
  return `${appConstants.BACKEND_ROOT}/login/linkedin-oauth2/?next=${encodeURIComponent(authUrl)}`;
};
